import { useMutation } from "@tanstack/react-query";

import { setUserRole } from "@/generated/api/users";

const useUserRoleMutation = () =>
  useMutation({
    mutationFn: ({
      userCompanyRelationId,
      role,
    }: {
      userCompanyRelationId: number;
      role: "USER" | "STATUTORY";
    }) => setUserRole(userCompanyRelationId, role),
  });

export { useUserRoleMutation };
